import { Navigate, useParams } from 'react-router-dom'

/** Rotas antigas (/tasks/new, /tasks/:id, /tasks/:id/edit) → tela de tarefas com a gaveta aberta. */
export function LegacyTaskRedirect() {
  const { id } = useParams()
  const target = id && /^\d+$/.test(id) ? id : 'nova'
  return <Navigate to={`/tasks?tarefa=${target}`} replace />
}
